<template>
  <div>
    <a-card>
      <span slot="title">Master Birthday</span>
      <div slot="extra" class="d-flex flex-row items-center">
        <span>Periode : </span>
        <a-month-picker placeholder="Select periode" v-model="periode" @change="onChangeDate" />
      </div>
    </a-card>
    <!-- :scroll="{ x: 1200, y:500}"  -->
    <a-table :columns="columns" :data-source="data" bordered style="margin-top: 10px;"
        :pagination="false" 
        :scroll="widthScreen < 400 ? { x: 1200, y:500} : {}"
        :loading="loading.table" size="small"
        key="tblMonitoring" :rowKey="(record, index) => {return index;}"
        >
        <template slot="no" slot-scope="value, item, index">{{ index + 1 }}</template>
        <template slot="tgl" slot-scope="value, item, index">{{ formatDate(item.tgl_lahir) }}</template>
        <template slot="quotes" slot-scope="value, item, index">
          <span>"{{ item.quotes }}"</span>
        </template>
        <template slot="photo" slot-scope="value, item, index">
          <div
            class="photo-wrapper img-preview"
            style="width: 50px; height: 50px; position: relative; cursor: pointer;"
            @click="previewPhoto(item.photo !== null ? $serviceUrl + item.photo : defaultImage, item.nama)"
          >
            <img
              class="photo-profile"
              alt="birthday-photo"
              :src="item.photo !== null ? $serviceUrl + item.photo : defaultImage"
              style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px;"
            />
            <div class="overlay-eye">
              <a-icon type="eye" />
            </div>
          </div>
        </template>
        <template slot="action" slot-scope="value, item, index">
          <div>
            <a-button type="primary" shape="circle" icon="form" @click="showModal(item)"/>
          </div>
        </template>

      </a-table>

    <a-modal
      :dialog-style="{ top: '20px' }"
      title="Edit data birthday"
      :visible="visibleModal"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading.btn_submit"
          @click="handleSubmit"
          >Submit</a-button
        >
      </template>

      <p>Nama : {{ state.data.nama }}</p>
      <a-form class="m-form" :form="form">
        
        <a-form-item label="Upload Photo" :required="true">
          <a-upload
            :customRequest="handleUpload"
            list-type="picture-card"
            :file-list="fileList"
            @preview="handlePreviewUpload"
            @change="handleChangeUpload"
            :getValueFromEvent="normFile"
            v-decorator="['photo', {
              rules: [{
                required: true,
                message: 'Photo is required!'
              },
             {
                validator: validateImageFile
              }]
            }]"
          >
            <div v-if="fileList.length < 1">
              <a-icon type="camera" />
              <div class="ant-upload-text">
                Upload
              </div>
            </div>
          </a-upload>
          <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelUpload">
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </a-form-item>

        <a-form-item label="Quotes" :required="true">
          <a-textarea
            placeholder="Input quotes"
            :auto-size="{ minRows: 3, maxRows: 5 }"
            v-decorator="['quotes', {
              rules: [{
                required: true,
                message: 'Quotes is required!'
              }],
              initialValue: state.data.quotes
            }]"
          />
        </a-form-item>

      </a-form>
    </a-modal>

    <a-modal
      :dialog-style="{ top: '20px' }"
      :title="titleModal"
      :visible="visibleModalPhoto"
      @cancel="visibleModalPhoto=!visibleModalPhoto"
      :footer="null"
    >
      <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
        <div class="photo-wrapper m-bottom" style="width: 300px; height: 300px;">
          <img
            class="photo-profile"
            alt="birthday-photo"
            :src="imgModal"
          />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Axios from 'axios';
import { mapGetters } from "vuex";
import moment from "moment-business-days"

const columns = [
  {
    title: 'No',
    width: 40,
    className: 'center',
    scopedSlots: { customRender: 'no' },
  },
  {
    title: 'Tgl Lahir',
    dataIndex: 'tgl_lahir',
    sorter: true,
    scopedSlots: { customRender: 'tgl' },
  },
  {
    title: 'Nama',
    dataIndex: 'nama',
    sorter: true,
    scopedSlots: { customRender: 'nama' },
  },
  {
    title: 'Unit Kerja',
    dataIndex: 'nama_dept',
  },
  {
    title: 'Quotes',
    dataIndex: 'quotes',
    className: 'quotes-column',
    scopedSlots: { customRender: 'quotes' },
  },
  {
    title: 'Photo',
    width: 70,
    dataIndex: 'photo',
    className: 'center',
    scopedSlots: { customRender: 'photo' },
  },
  {
    title: 'Action',
    width: 70,
    className: 'center',
    scopedSlots: { customRender: 'action' },
  }
];

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export default {
  data(){
    return {
      base_url: this.$serviceUrl,
      defaultImage: '/user_default.jpg',
      data: [],
      pagination: {},
      loading: false,
      columns,
      periode: null,
      loading: {
        table: false,
        btn_submit: false
      },
      visibleModal: false,
      visibleModalPhoto: false,
      state: {
        data: {},
        edit_id: ''
      },
      previewVisible: false,
      previewImage: '',
      imgModal: '',
      titleModal: '',
      fileList: [],
      photoPath: '',
      photoName: '',
      widthScreen: 0,
      heighScreen: 0
    }
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate","getDefaultDateFormat"]),
  },

  beforeCreate() {
    this.form = this.$form.createForm(this);
  },

  created(){
    const queryPeriode = this.$route.query.periode;
    if (queryPeriode) {
      const parsedDate = new Date(queryPeriode);
      // Cek apakah valid
      this.periode = isNaN(parsedDate.getTime())
        ? new Date().toISOString() // fallback kalau invalid
        : parsedDate.toISOString();

        this.$router.replace({ query: {} });
    } else {
      this.periode = new Date().toISOString();
    }
    this.fetchData()
  },

  mounted(){
    this.fetchData()
    this.widthScreen = window.innerWidth
    this.heighScreen = window.innerHeight
    console.log(this.widthScreen);
    
  },

  methods: {
    async fetchData(){
      this.loading.table = true
      try {
        const response = await Axios({
          method: 'GET',
          url: this.$serviceUrl + "birthday/list",
          params: {
            "X-API-KEY": this.getAuth.apikey,
            periode: new Date(this.periode).toISOString().slice(0, 10),
          },
          auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
          },
        })

        this.loading.table = false
        if(response) {            
          this.data = response.data.data
        }
        
      } catch (error) {
        this.loading.table = false
        console.log(error);
      }
    },

    onChangeDate(event){
      this.fetchData()
    },

    async showModal(data){
      this.visibleModal = true
      this.state.edit_id = data.birthday_id
      this.state.data = data

      if(data.photo !== null){
        const photoPath = data.photo;
        const fileName = photoPath.split('/').pop();
        
        try {
          const response = await Axios({
            method: 'GET',
            url: this.$serviceUrl + "birthday/photo",
            params: {
              "X-API-KEY": this.getAuth.apikey,
              file: fileName,
            },
            auth: {
                username: this.getAuth.username,
                password: this.getAuth.password
            },
            responseType: 'blob'
          })          
          
          const file = new File([response.data], fileName, {
            type: response.data.type, // contoh: image/jpeg
          });
          
          this.photoName = fileName
          this.fileList =[
            {
              uid: '-1',
              name: fileName,
              status: 'done',
              url: this.$serviceUrl + data.photo,
              originFileObj: file,
              type: response.data.type
            }
          ]

          this.form.setFieldsValue({
            photo: {
              file: this.fileList[0],
              fileList: this.fileList
            }
          })
          
        } catch (error) {
          console.log(error);
        }
      }
    },

    handleCancel(){
      this.visibleModal = false
      this.clearForm()
    },

    clearForm(){
      this.state.edit_id = ''
      this.state.data = {}
      this.form.resetFields();
      this.previewImage = ''
      this.fileList = []
    },

    handleCancelUpload() {
      this.previewVisible = false;
    },
    async handlePreviewUpload(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChangeUpload({ fileList }) {
      this.fileList = fileList;
    },

    handleSubmit(){
      this.loading.btn_submit = true
      
      this.form.validateFields( async (err, values) => {

        if (err) {
          this.loading.btn_submit = false
          this.displayMessage("form-warning");
          return;
        }
        
        try {
          let formData = new FormData()

          formData.append("photo", values.photo.file.originFileObj);
          formData.append("quotes", values.quotes)
          formData.append("birthday_id", this.state.edit_id)
          formData.append("periode", this.state.data.periode)
          formData.append("tlc", this.state.data.tlc)
          const response = await Axios({
            method: 'POST',
            url: this.$serviceUrl + "birthday/update",
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey
            }
          })

          if(response){
            this.fetchData()
            this.visibleModal = false
            this.clearForm()
            this.displayMessage("success-save");
          }
          this.loading.btn_submit = false

        } catch (error) {
          console.log(error);
          this.loading.btn_submit = false
        }
      });
    },
    
    async handleUpload({ file, onSuccess, onError, onProgress }){
      try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await Axios({
          method: 'POST',
          url: this.$serviceUrl + "birthday/upload",
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey
          },
          onUploadProgress: (event) => {
            const percent = Math.round((event.loaded / event.total) * 100);
            onProgress({ percent });
          }
        })

        onSuccess(response.data);
      } catch (error) {
        onError(error);
        
      }
    },

    validateImageFile(rule, value, callback) {
      if (!value || value.length === 0) {
        return callback('Please upload an image');
      }
      
      const file = value.file;
      const allowedTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif', 'image/webp'];

      if (!allowedTypes.includes(file.type)) {
        return callback('Only image files are allowed');
      }

      return callback();
    },

    formatDate(date){
      return moment(date).format('DD-MM');
    },

    previewPhoto(img, name){
      this.imgModal = img
      this.visibleModalPhoto = true
      this.titleModal = name
    },

    normFile(e) {
      console.log('Upload event:', e);
      // Jika multiple: return e.fileList
      return e && e.fileList;
    },
  }
}
</script>

<style lang="less">
.items-center {
  align-items: center;
  gap: 10px;
}

th.center,
td.center {
  text-align: center !important;
}

th.quotes-column,
td.quotes-column {
  text-align: center !important;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.overlay-eye {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* gelap transparan */
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: 0.3s ease;
  border-radius: 4px;
}
.photo-wrapper:hover .overlay-eye {
  opacity: 1;
}
.overlay-eye .anticon {
  color: #fff;
  font-size: 20px;
}
</style>

